// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"d2063c39","243":"975ab808","297":"56c5f332","575":"fa8ffcdd","704":"34d9165c"}[chunkId] + ".chunk.css";
};